import { render, staticRenderFns } from "./list-settle.vue?vue&type=template&id=edd66b66&scoped=true&"
import script from "./list-settle.vue?vue&type=script&lang=js&"
export * from "./list-settle.vue?vue&type=script&lang=js&"
import style0 from "./list-settle.vue?vue&type=style&index=0&id=edd66b66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd66b66",
  null
  
)

export default component.exports